export default function selectMany(array, selector) {
    return array.reduce((results, t) => [...results, ...selector(t)], []);
}
